<template>
    <div :class="withPadding ? 'py-2' : ''">
        <strong>Razão Social: </strong>{{ client.legal_name }} <br>
        <strong>Nome Fantasia: </strong>{{ client.trade_name }} {{ client.main_company_id ? '(filial)' : '' }} <br>
        <strong>Schema: </strong>{{ client.tenant?.contractId ?? client.tenant?.contract_id ?? 'N/A' }} <br>
        <strong>Login Code: </strong>{{ client.tenant?.login_code ?? 'N/A' }} <br>
        <strong>Conexão: </strong>{{ client.tenant?.connection ?? 'N/A' }} <br>

        <strong v-if="isCpfFormatted(client.document)">CPF: </strong>
        <strong v-else>CNPJ: </strong>
        {{ client.document }} <br>

        <template v-if="client.first_plan_at">
            <strong>Ativação da conta em: </strong>
            {{ client.firstPlanAt }} <br>
        </template>

        <template v-if="client.subscriptionId">
            <strong>Assinatura: </strong>
            <a :href="`${vindiUri}${client.subscription}`" target="_blank">{{ client.subscriptionId }}</a> <br>
        </template>

        <template v-if="showExtraData && can('index plan-consultant') && client.currentPlan">
            <strong>Consultor: </strong>{{ client.currentPlan.consultant }} <br>
        </template>

        <template v-if="showStatus">
            <br>
            <v-chip
                :color="client.statusColor"
                text-color="white"
                label
                small
                class="mb-2"
            >
                {{ client.status }}
            </v-chip><br>

            <v-chip
                :color="client.situationColor"
                text-color="white"
                label
                small
                class="mb-2"
            >
                {{ client.situation }}
            </v-chip><br>

            <v-chip
                :color="client.partnerColor"
                :text-color="client.partnerTextColor"
                label
                small
                class="mb-2"
            >
                {{ client.partner }}
            </v-chip><br>

            <v-chip v-if="client.holding_name"
                color="lime darken-3"
                text-color="white"
                label
                small
                class="mb-2"
            >
                Holding: {{ client.holding_name }}
            </v-chip>
            <br>
        </template>

        <template v-if="showExtraData && can('index payment-gateway') && client.payment_gateway_id">
            <br>
            <strong>ID Vindi:</strong>
            <a :href="`${vindiUri}${client.paymentGateway}`" target="_blank">{{ client.payment_gateway_id }}</a> <br>
        </template>

        <template v-if="showExtraData && can('index clients-extra')">
            <br>
            <strong>ID Empresa:</strong> {{ client.internal_id }} <br>
            <strong>ID Empresa Tenancy:</strong> {{ client.id }} <br>
            <strong>Tenant:</strong> {{ client.tenant_id }} <br>
            <template v-if="client.reseller_id > 1">
                <strong>Revendedor:</strong> {{ `${client.reseller_id} - ${client.reseller.trade_name}` }} <br>
            </template>
        </template>
    </div>
</template>

<script>
import documentMixin from '@core/mixins/document'

export default {
    mixins: [
        documentMixin,
    ],
    props: {
        client: {
            type: Object,
            required: true,
        },
        showExtraData: {
            type: Boolean,
            default: true
        },
        showStatus: {
            type: Boolean,
            default: false
        },
        withPadding: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        vindiUri() {
            return this.getConfig().vindi_uri;
        },
    },
}
</script>